if (!customElements.get('izuro-hero-reviews')) {
  customElements.define('izuro-hero-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.izuro-hero-reviews__track');
      this.previous = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.izuro-hero-review');
        if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
      }, options);
      this.observer = new ResizeObserver(() => this.updateControls());
      this.observer.observe(this.track);
      this.updateControls();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const style = getComputedStyle(this.track);
      const step = card.getBoundingClientRect().width + (parseFloat(style.columnGap) || 10);
      this.track.scrollBy({
        left: step * direction * (style.direction === 'rtl' ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    updateControls() {
      const position = Math.abs(this.track.scrollLeft);
      this.previous.disabled = position <= 1;
      this.next.disabled = position >= this.track.scrollWidth - this.track.clientWidth - 1;
    }
  });
}
